import { useMemo } from 'react';
import UIFlex from 'UIComponents/layout/UIFlex';
import { Flex } from 'foundations-components/components/Flex';
import LoadingSkeleton from 'framework-listing-lib/internal/shared/components/LoadingSkeleton';
import { useHasFoldersTab } from 'framework-listing-lib/internal/Folders/hooks/useFolderProps';
import { useIsFoldersMode } from 'framework-listing-lib/internal/hooks/useUIMode';
import { DEFAULT_PADDING, DEFAULT_PADDING_TOKEN, FILTER_BAR_HEIGHT } from 'framework-listing-lib/constants/sizes';
import FolderListSkeleton from './FolderListSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CrmListingFoldersSkeleton() {
  const hasFoldersTab = useHasFoldersTab();
  const isFoldersMode = useIsFoldersMode();
  const shouldRenderUIModeToggle = useMemo(() => !hasFoldersTab && isFoldersMode, [hasFoldersTab, isFoldersMode]);
  return /*#__PURE__*/_jsxs(UIFlex, {
    "data-test-id": "crm-listing-folders-skeleton",
    direction: "column",
    children: [shouldRenderUIModeToggle && /*#__PURE__*/_jsxs(Flex, {
      "data-test-id": "ui-mode-toggle",
      inlineSize: "120px",
      marginBlockStart: "200",
      marginInlineStart: "100",
      children: [/*#__PURE__*/_jsx(LoadingSkeleton, {
        blockSize: "32px",
        inlineSize: "60px"
      }), /*#__PURE__*/_jsx(LoadingSkeleton, {
        blockSize: "32px",
        inlineSize: "60px"
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      "data-test-id": "folder-actions-skeleton",
      flexDirection: "row",
      justifyContent: "space-between",
      blockSize: `${FILTER_BAR_HEIGHT + DEFAULT_PADDING}px`,
      inlineSize: "100%",
      paddingInlineStart: DEFAULT_PADDING_TOKEN,
      children: [/*#__PURE__*/_jsx(LoadingSkeleton, {
        blockSize: "16px",
        inlineSize: "100px"
      }), /*#__PURE__*/_jsx(LoadingSkeleton, {
        blockSize: "16px",
        inlineSize: "80px"
      })]
    }), /*#__PURE__*/_jsx(FolderListSkeleton, {
      total: 11
    })]
  });
}